import React from 'react';
import styled from 'styled-components';
import TpIcapCardHeader from '../../features/tpIcapCardHeader/TpIcapCardHeader';
import { formatUploadHeaderDate } from '../../common/formatters';
import {
  Table,
  UncontrolledCollapse,
  Row,
  Col,
  Label,
  Card,
  CardBody,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Spinner,
} from 'reactstrap';
import config from '../../config';
import { downloadLogs } from '../../features/uploads/uploadsMiddleware';

const TableSmall = styled(Table)`
  font-size: 10px;
`;

const MAX_PAGINATION_ITEMS = config.uploadsPaginationItems;
const MAX_NUMBER_OF_COLUMNS = config.uploadsPreviewColumns;

function Preview(props) {
  const { headers, rows } = props;
  return (
    <TableSmall hover>
      <thead>
        <tr>
          {headers.slice(0, MAX_NUMBER_OF_COLUMNS).map((field) => (
            <th key={`field-${field}`}>{field}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          //eslint-disable-next-line
          <tr key={`row-${i}`}>
            {row.slice(0, MAX_NUMBER_OF_COLUMNS).map((field, i) => (
              //eslint-disable-next-line
              <td key={`row-${i}-field-${headers[i]}`}>{field}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </TableSmall>
  );
}
function FileName(props) {
  const { fileName, filter } = props;
  if (filter.fileName) {
    const idx = fileName.toLowerCase().indexOf(filter.fileName.toLowerCase());
    return (
      <>
        <span>{fileName.substring(0, idx)}</span>
        <span style={{ backgroundColor: '#ffe21e' }}>{filter.fileName}</span>
        <span>{fileName.substring(idx + filter.fileName.length)}</span>
      </>
    );
  }
  return props.fileName;
}

/**
 * Upload card component
 * @param {*} props
 */
export class UploadCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props, isDownloading: false };
  }
  render() {
    const { upload, filter } = this.props;
    return (
      <Card>
        <TpIcapCardHeader>
          <Row>
            <Col md="auto" className="mr-auto">
              {upload.uploadSucceeded ? (
                <h4 className="mt-0">
                  Uploaded {formatUploadHeaderDate(upload.uploadDate)}
                </h4>
              ) : (
                <h4 className="mt-0 text-danger">Upload Failed</h4>
              )}
            </Col>
          </Row>
        </TpIcapCardHeader>
        <CardBody>
          <Row className="mb-2">
            <Col>
              <Label className="tpicap-label">Filename</Label>
              <FileName fileName={upload.fileName} filter={filter} />
            </Col>
            <Col>
              <Label className="tpicap-label">Upload Agent</Label>
              {upload.uploadAgent}
            </Col>
            <Col>
              <Label className="tpicap-label">Upload Date and Time</Label>
              {formatUploadHeaderDate(upload.uploadDate)}
            </Col>
            <Col>
              <Label className="tpicap-label">Number of Row Errors</Label>
              {upload.validationErrorCount}
            </Col>
            <Col>
              <Label className="tpicap-label">
                Number of Potential Duplicates
              </Label>
              {upload.duplicateCount}
            </Col>
            {!upload.uploadSucceeded && upload.errors !== null ? (
              <Col>
                <Label className="tpicap-label">Errors</Label>
                {upload.errors}
              </Col>
            ) : null}
            {!upload.uploadSucceeded && upload.errors === null ? (
              <Col>
                <Label className="tpicap-label">Errors</Label>
                An error has occured. Please check the log files.
              </Col>
            ) : null}
          </Row>
          <Row>
            <Col md="auto" className="mr-auto"></Col>
            {upload.uploadSucceeded ? (
              <Button
                className="tpicap-thin-outline-button"
                size="sm"
                color="default"
                outline
                onClick={() => {
                  this.props.onMoreDetails && this.props.onMoreDetails(upload);
                }}
              >
                More...
              </Button>
            ) : null}
            {upload.uploadSucceeded ? (
              <Button
                id={`toggler-${upload.ingestId}`}
                className="tpicap-thin-outline-button"
                size="sm"
                color="default"
                outline
              >
                Preview
              </Button>
            ) : null}
            <Button
              className="tpicap-thin-outline-button"
              size="sm"
              color="default"
              outline
              onClick={async () => {
                this.setState({ isDownloading: true });
                const logReady = await downloadLogs(upload);
                if (!logReady) this.props.downloadError(upload);
                this.setState({ isDownloading: false });
              }}
            >
              Download Logs
              {this.state.isDownloading && (
                <span style={{ paddingLeft: '1em' }}>
                  <Spinner size="sm" />
                </span>
              )}
            </Button>
          </Row>
          <Row>
            {upload.uploadSucceeded ? (
              <UncontrolledCollapse
                className="mx-auto mt-4"
                toggler={`#toggler-${upload.ingestId}`}
                onEntering={() => {
                  this.props.onDetails &&
                    this.props.onDetails(upload, (upload) => {
                      this.setState({ upload });
                    });
                }}
              >
                {upload.preview == null ? (
                  <div style={{ textAlign: 'center' }}>
                    <Spinner size="sm" />
                  </div>
                ) : (
                  <Preview {...upload.preview} />
                )}
              </UncontrolledCollapse>
            ) : null}
          </Row>
        </CardBody>
      </Card>
    );
  }
}

export class Paginator extends React.Component {
  constructor(props) {
    super(props);
    this.onPage = props.onPage;
  }

  handlePageClick(page) {
    this.onPage &&
      this.onPage(Math.min(Math.max(0, page), this.props.pages - 1));
  }

  render() {
    const items = ((items) => {
      var maxItems = Math.min(this.props.pages, MAX_PAGINATION_ITEMS);
      var offset = Math.max(this.props.current - Math.floor(maxItems * 0.5), 0);
      offset -= Math.max(offset + maxItems - this.props.pages, 0);

      for (var k = 0; k < maxItems; k++) {
        const i = k + offset;
        items.push(
          <PaginationItem key={i} active={this.props.current === i}>
            <PaginationLink
              value={i}
              onClick={(e) => this.handlePageClick(+e.currentTarget.value)}
            >
              {i + 1}
            </PaginationLink>
          </PaginationItem>,
        );
      }
      return items;
    })([]);

    return (
      <Pagination>
        <PaginationItem>
          <PaginationLink
            onClick={(e) => this.handlePageClick(this.props.current - 1)}
          >
            {'<'}
          </PaginationLink>
        </PaginationItem>
        {items}
        <PaginationItem>
          <PaginationLink
            onClick={(e) => this.handlePageClick(this.props.current + 1)}
          >
            {'>'}
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    );
  }
}
